module.exports = __webpack_public_path__ + "img/font_xiao@2x.1202831e.png";